/**
 * PAI's app-level loading overlay.
 *
 * Renders the shared PAI loading screen defined in {@link paiLoadingContent}.
 * The same content is injected into index.html by the Vite plugin (see
 * `vite.config.ts → paiLoadingPlugin`), so the pre-React loading phase
 * and this React overlay look identical — no flash of different content.
 *
 * CSS is already present in `<head>` via the Vite HTML plugin, so no
 * `<style>` injection is needed here.
 *
 * `dangerouslySetInnerHTML` is safe: {@link LOADING_HTML} is a static
 * constant authored in this repo, never derived from user input.
 */
import {LOADING_HTML} from './paiLoadingContent';

export function PaiLoadingPage() {
  // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
  return <div dangerouslySetInnerHTML={{__html: LOADING_HTML}} />;
}
